import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Check, ChevronDown } from "lucide-react";
import { useCurrency, CCY_SYMBOLS } from "@/context/CurrencyContext";

export default function CurrencySwitcher({ compact = false }) {
  const { currency, setCurrency, supported } = useCurrency();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative" data-testid="currency-switcher">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="currency-switcher-btn"
        className="pressable glass flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-semibold"
        style={{ color: "var(--text)" }}
      >
        <span className="accent">{CCY_SYMBOLS[currency]}</span>
        {!compact && <span>{currency}</span>}
        <ChevronDown size={14} className="text-dim" />
      </button>
      <AnimatePresence>
        {open && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
            <motion.div
              initial={{ opacity: 0, y: -8, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -8, scale: 0.96 }}
              transition={{ type: "spring", stiffness: 400, damping: 30 }}
              className="glass absolute right-0 z-50 mt-2 w-40 overflow-hidden rounded-2xl p-1.5"
              style={{ boxShadow: "var(--shadow)" }}
            >
              {supported.map((c) => (
                <button
                  key={c}
                  data-testid={`ccy-opt-${c}`}
                  onClick={() => { setCurrency(c); setOpen(false); }}
                  className="pressable flex w-full items-center justify-between rounded-xl px-3 py-2 text-sm font-medium"
                  style={{ color: "var(--text)", background: c === currency ? "var(--surface-2)" : "transparent" }}
                >
                  <span><span className="accent mr-2">{CCY_SYMBOLS[c]}</span>{c}</span>
                  {c === currency && <Check size={15} className="accent" />}
                </button>
              ))}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
}
